import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOWartungsHistoryListStatus: 'idle',
    loadTOWartungsHistoryListError: undefined as any,
    loadTOWartungsHistoryListLastArgs: undefined as any,
    loadTOWartungsHistoryStatus: 'idle',
    loadTOWartungsHistoryError: undefined as any,

    tOWartungsHistoryList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOWartungsHistoryList = createAsyncThunk('toWartungsHistorySlice/loadTOWartungsHistoryList', async ({ gridFilters, globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toWartungsHistorySlice.loadTOWartungsHistoryListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/towartungshistory/`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOWartungsHistoryListStatus } = getState().toWartungsHistorySlice
        return loadTOWartungsHistoryListStatus !== 'pending'
    }
})

export const loadTOWartungsHistory = createAsyncThunk('toWartungsHistorySlice/loadTOWartungsHistory', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/towartungshistory/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOWartungsHistoryStatus } = getState().toWartungsHistorySlice
        return loadTOWartungsHistoryStatus !== 'pending'
    }
})

const TOWartungsHistorySlice = createSlice({
    name: 'toWartungsHistorySlice',
    initialState,
    reducers: {
        resetloadTOWartungsHistoryListError: (state) => {
            state.loadTOWartungsHistoryListError = undefined
        },
        resetloadTOWartungsHistory: (state) => {
            state.formItem = undefined
            state.loadTOWartungsHistoryError = undefined
        },
        resetloadTOWartungsHistoryError: (state) => {
            state.loadTOWartungsHistoryError = undefined
        },
        removeFromTOWartungsHistoryListById: (state, action) => {
            state.tOWartungsHistoryList = state.tOWartungsHistoryList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromTOWartungsHistoryListByIds: (state, action) => {
            state.tOWartungsHistoryList = state.tOWartungsHistoryList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.tOWartungsHistoryList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOWartungsHistoryListStatus = 'preloaded'
            state.loadTOWartungsHistoryListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.tOWartungsHistoryList = []
            state.loadTOWartungsHistoryListStatus = 'idle'
            state.loadTOWartungsHistoryListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOWartungsHistoryList.pending, (state) => {
            state.loadTOWartungsHistoryListStatus = 'pending'
            state.loadTOWartungsHistoryListError = undefined
        })
        builder.addCase(loadTOWartungsHistoryList.fulfilled, (state, action) => {
            state.loadTOWartungsHistoryListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOWartungsHistoryListLastArgs = action.payload.args

            {
                state.tOWartungsHistoryList = action.payload.data

            }
        })
        builder.addCase(loadTOWartungsHistoryList.rejected, (state, action) => {
            state.loadTOWartungsHistoryListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOWartungsHistoryListError = action.error.message
            } else {
                state.loadTOWartungsHistoryListError = action.payload
            }
        })

        builder.addCase(loadTOWartungsHistory.pending, (state) => {
            state.loadTOWartungsHistoryStatus = 'pending'
            state.loadTOWartungsHistoryError = undefined
        })
        builder.addCase(loadTOWartungsHistory.fulfilled, (state, action) => {
            state.loadTOWartungsHistoryStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOWartungsHistoryList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOWartungsHistoryList.push(newItem) }
                else { state.tOWartungsHistoryList[i] = { ...state.tOWartungsHistoryList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOWartungsHistory.rejected, (state, action) => {
            state.loadTOWartungsHistoryStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOWartungsHistoryError = action.error.message
            } else {
                state.loadTOWartungsHistoryError = action.payload
            }
        })

    }
})

export const {
    resetloadTOWartungsHistoryListError,
    resetloadTOWartungsHistory,
    resetloadTOWartungsHistoryError,
    removeFromTOWartungsHistoryListById,
    removeFromTOWartungsHistoryListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = TOWartungsHistorySlice.actions
export default TOWartungsHistorySlice.reducer
